class TaskQueue {
    constructor(maxConcurrent) {
        this.maxConcurrent = maxConcurrent;
        this.currentCount = 0;
        this.queue = [];
    }

    add(task) {
        return new Promise((resolve, reject) => {
            const wrappedTask = () => {
                return task()
                    .then((result) => {
                        resolve(result);
                        return result;
                    })
                    .catch((err) => {
                        if (err !== undefined) {
                            reject(err);
                            throw err;
                        }
                    });
            };

            this.queue.push(wrappedTask);
            this.processQueue();
        });
    }

    processQueue() {
        if (this.currentCount >= this.maxConcurrent) {
            return;
        }

        const nextTask = this.queue.shift();
        if (!nextTask) {
            return;
        }

        this.currentCount++;
        nextTask()
            .finally(() => {
                this.currentCount--;
                this.processQueue();
            });
    }
}

export const KonvaComponentPhotoLoadQueue = new TaskQueue(5);